module.exports = __webpack_public_path__ + "img/psicotropicos.152249da.png";